import { Col, Row } from 'react-bootstrap';
import { Loader, ModalGeneric, SelectGeneric } from 'ypf-pas-general-ui-components';
import { useHistory } from 'react-router-dom';
import { useState, useEffect, useCallback } from 'react';
import PropTypes from 'prop-types';

import {
  getBudgetService,
  getImputationDefault,
  getImputationType,
  getImputationsDetails,
  getLaterEvents
} from '../../../../services/yclickMaster';
import { aprobador, proveedorNotificador } from '../../../../security/constantsRols';
import { checkRol } from '../../../../security';
import {
  eventPendingAssignmentId,
  eventPendingAssignmentName,
  imputationTypeEnum
} from '../../../../utils/dataStatus';
import {
  editEventForServiceRequest,
  getDetailUbicationWithoutEvent
} from '../../../../services/serviceRequest';
import AccountAssignmentObjectDetail from '../../../../components/Wells/AccountAssignmentObjectDetail/AccountAssignmentObjectDetail';
import AccountAssignmentObjectForm from '../../../../components/Wells/AccountAssignmentObjectForm/AccountAssignmentObjectForm';
import useToast from '../../../../hooks/useToast';
import { editEventsForServiceRequestAdpater } from '../../../../adapters/requestServiceDetails/editEventsForServiceRequestAdpater';

import './AddEventModal.scss';
import { mapEventForSelect } from './utils';

const AddEventModal = ({
  showAddEventModal,
  ubicationType,
  setShowAddEventModal,
  requestId,
  setWithOutEventAssigned
}) => {
  const [operationType, setOperationType] = useState(null);
  const [imputationTypeOptions, setImputationTypeOptions] = useState();
  const [wells, setWells] = useState([]);
  const [loading, setLoading] = useState(false);

  const mockEventPendingOfAsignation = {
    id: eventPendingAssignmentId,
    sigla: 'EPAA',
    nombre: eventPendingAssignmentName,
    label: eventPendingAssignmentName
  };
  const history = useHistory();
  const { setNewToast } = useToast();

  const pendingEventWasSelected = wells.some(
    (well) => well?.event?.id === eventPendingAssignmentId
  );
  const isApprover = checkRol(aprobador);
  const isProvider = checkRol(proveedorNotificador);

  const goToRequestGrid = () => {
    history.push('/');
  };

  const getWells = useCallback(async () => {
    try {
      setLoading(true);
      const wellsResponse = await getDetailUbicationWithoutEvent({ requestId });

      return wellsResponse;
    } catch (error) {
      setNewToast({
        type: 'ERROR',
        message: error.message
      });

      return [];
    } finally {
      setLoading(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const mapImputationObject = async ({ well, onChange = false, event }) => {
    const [responseImpDefault] = await getImputationDefault([
      {
        pozoId: well?.pozo?.id,
        eventoId: isApprover ? well?.selectedEvent?.realId : event?.realId,
        eventoPozoId: isApprover && !onChange ? well?.idEventoPozo : event?.eventoPozoId
      }
    ]);

    const [responseImputationDetail] = await getImputationsDetails([
      {
        pozoId: well?.pozo?.id,
        tipoId: responseImpDefault?.tipoImputacion?.id,
        objetoId: responseImpDefault?.objetoImputacion?.id
      }
    ]);

    const resBudget =
      responseImpDefault?.tipoImputacion?.id === imputationTypeEnum.PEP
        ? await getBudgetService(responseImpDefault?.objetoImputacion?.id)
        : null;

    return {
      wellIndex: well?.wellIndex,
      imputationObject: {
        ...responseImpDefault.objetoImputacion,
        label: responseImpDefault.objetoImputacion?.codigo,
        nombre: responseImpDefault.objetoImputacion?.codigo
      },
      imputationType: {
        ...responseImpDefault.tipoImputacion,
        label: responseImpDefault.tipoImputacion?.nombre,
        nombre: responseImpDefault.objetoImputacion?.codigo
      },
      state: responseImputationDetail?.estado,
      budget: resBudget?.presupuesto,
      logisticCenter: responseImputationDetail?.centroLogistico,
      socCode: responseImputationDetail?.sociedadCodigo,
      soc: responseImputationDetail?.sociedadLogo,
      description: responseImputationDetail?.descripcion,
      warningBudget: responseImputationDetail?.warningBudget,
      warningState: false
    };
  };

  const getImputationObject = async ({ event, onChange = false, well }) => {
    try {
      setLoading(true);
      let auxImputationObject = {};

      if (!(event?.realId === eventPendingAssignmentId || pendingEventWasSelected)) {
        auxImputationObject = await mapImputationObject({ onChange, well, event });
      }

      const mappedWells = wells.map((wellMap) => {
        if (wellMap?.wellIndex === auxImputationObject.wellIndex) {
          return {
            ...wellMap,
            imputationObject: auxImputationObject,
            selectedEvent: onChange ? event : well?.selectedEvent
          };
        }

        return { ...wellMap, selectedEvent: onChange ? event : well?.selectedEvent };
      });

      setWells(mappedWells);
    } catch (error) {
      setNewToast({
        type: 'ERROR',
        message: error.message
      });
    } finally {
      setLoading(false);
    }
  };
  const getDefaultOptions = (eventOptionsResponse) =>
    eventOptionsResponse?.opciones?.length ? eventOptionsResponse.opciones : [];

  const getSelectedEvent = (wellsResponse) =>
    wellsResponse?.evento?.nombre === eventPendingAssignmentName && !isApprover
      ? mapEventForSelect(mockEventPendingOfAsignation)
      : mapEventForSelect({
          ...wellsResponse?.evento,
          label: wellsResponse?.evento?.nombre
        });

  const getIntialData = useCallback(async () => {
    try {
      setLoading(true);
      const [wellsResponse, imputationTypeOptionsResponse] = await Promise.all([
        getWells(),
        getImputationType()
      ]);

      const mappedWells = await Promise.all(
        wellsResponse?.pozos?.map(async (well, index) => {
          try {
            const eventOptionsResponse = await getLaterEvents({
              wellId: well?.pozo?.id,
              eventTypeId: wellsResponse?.evento?.id,
              createDate: wellsResponse?.fechaCreacion
            });

            setOperationType({
              id: wellsResponse?.evento?.id,
              label: wellsResponse?.evento?.sigla
            });

            const defaultOptions = getDefaultOptions(eventOptionsResponse);

            const eventOptions = [
              ...defaultOptions.map((event) => mapEventForSelect(event)),
              ...[mapEventForSelect(mockEventPendingOfAsignation)]
            ];

            return {
              ...well,
              eventOptions,
              selectedEvent: getSelectedEvent(wellsResponse),
              wellIndex: index,
              unidadNegocio: wellsResponse.unidadNegocio,
              warning:
                eventOptionsResponse?.opciones?.length > 1
                  ? 'Existe más de un evento disponible para ese pozo en el mismo rango de fechas'
                  : undefined,
              error:
                !eventOptionsResponse?.opciones ||
                (isApprover && eventOptionsResponse?.opciones.length === 1)
                  ? 'El pozo no tiene eventos asociados para modificar.'
                  : undefined,
              imputationObject: !isApprover ? [] : await mapImputationObject({ well, event: {} })
            };
          } catch (error) {
            setNewToast({
              type: 'ERROR',
              message: error.message
            });

            return {
              eventOptions: [],
              wellIndex: index,
              warning: '',
              error: ''
            };
          }
        })
      );

      setImputationTypeOptions(imputationTypeOptionsResponse);
      setWells(mappedWells);
    } catch (err) {
      setNewToast({
        type: 'ERROR',
        message: err.message
      });
    } finally {
      setLoading(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [getWells, isApprover, setNewToast]);

  const closeModal = () => {
    setShowAddEventModal(false);
  };

  const submitEvent = async () => {
    try {
      await editEventForServiceRequest({
        requestId,
        body: editEventsForServiceRequestAdpater({
          wells,
          requestId
        })
      });

      setNewToast({
        type: 'SUCCESS',
        message: 'Se editó el evento correctamente'
      });
      if (isProvider) setWithOutEventAssigned(false);
      closeModal();
    } catch (error) {
      setNewToast({
        type: 'ERROR',
        message: error.message
      });
    }
  };

  useEffect(() => {
    getIntialData();
  }, [getIntialData]);

  const someOneHasError = wells.some((well) => well.error);

  return (
    <ModalGeneric
      backdrop="static"
      infoModal
      onHide={isApprover ? closeModal : goToRequestGrid}
      primaryAction={submitEvent}
      primaryActionDisabled={
        pendingEventWasSelected ||
        someOneHasError ||
        !wells[0]?.imputationObject?.imputationObject?.id
      }
      primaryActionLabel={isApprover ? 'Editar Evento' : 'Asignar Evento'}
      secondaryAction={isApprover ? closeModal : goToRequestGrid}
      secondaryActionLabel={isApprover ? 'Salir' : 'Volver a bandeja'}
      show={showAddEventModal}
      size="xl"
      title={isApprover ? 'Editar evento de solicitud' : 'Asignar evento a solicitud'}
    >
      <div>
        {!isApprover && (
          <>
            <h3>Para continuar debe asignar un evento</h3>
            <hr />
          </>
        )}

        {loading && <Loader show={loading} text="CARGANDO ..." />}
        {wells &&
          !loading &&
          wells?.map((well) => {
            const hasError = well.error?.length;
            const hasWarning = well.warning?.length;

            return (
              <>
                {hasWarning && <span className="multiple-warnings">{well.warning}</span>}

                {hasError && <span className="error-event">{well.error}</span>}
                <Row>
                  <Col sm={6}>
                    <SelectGeneric
                      isDisabled
                      label="Tipo de ubicación"
                      name="ubicacion"
                      options={[]}
                      placeholder="Ubicacion"
                      value={{ label: ubicationType?.nombre, nombre: ubicationType?.nombre }}
                      withSelect="100%"
                    />
                  </Col>
                  <Col sm={6}>
                    <SelectGeneric
                      isDisabled
                      label="Unidad de negocio"
                      name="businessUnit"
                      options={[]}
                      placeholder="Unidad de negocio"
                      value={{
                        label: well.unidadNegocio?.nombre,
                        nombre: well.unidadNegocio?.nombre
                      }}
                      withSelect="100%"
                    />
                  </Col>
                </Row>
                <Row>
                  <Col sm={6}>
                    <SelectGeneric
                      isDisabled
                      label="Ubicación pozo"
                      name="ubicacion"
                      options={[]}
                      placeholder="Ubicacion"
                      value={{ label: well.pozo.nombre, nombre: well.pozo.nombre }}
                      withSelect="100%"
                    />
                  </Col>
                  <Col sm={3}>
                    <SelectGeneric
                      isDisabled={someOneHasError}
                      label="Evento"
                      name="evento"
                      onChange={(newValue) => {
                        getImputationObject({ event: newValue, onChange: true, well });
                      }}
                      options={well?.eventOptions}
                      placeholder="Buscá por nombre"
                      value={well?.selectedEvent}
                      withSelect="100%"
                    />
                  </Col>

                  {(pendingEventWasSelected || (!well?.selectedEvent && !isApprover)) && (
                    <Col sm={3}>
                      <SelectGeneric
                        isDisabled
                        label="Tipo de operación"
                        name="operationType"
                        options={[]}
                        placeholder="Tipo de operación"
                        value={operationType}
                        withSelect="100%"
                      />
                    </Col>
                  )}
                  <Col sm={3}>
                    <SelectGeneric
                      isDisabled
                      label="Equipo"
                      name="team"
                      options={[]}
                      placeholder="Tipo de Operación"
                      value={{
                        label: well?.equipo.nombre,
                        nombre: well?.equipo.nombre
                      }}
                      withSelect="100%"
                    />
                  </Col>
                </Row>
                <Row>
                  <>
                    {well?.selectedEvent &&
                      !pendingEventWasSelected &&
                      well?.imputationObject?.imputationObject?.id && (
                        <div>
                          {/* TI y OI Form */}
                          <AccountAssignmentObjectForm
                            data={well?.imputationObject}
                            disabledForm={!isApprover || someOneHasError}
                            eventId={well?.selectedEvent?.realId}
                            imputationTypeOptions={imputationTypeOptions}
                            setLoading={setLoading}
                            wellId={well?.pozo?.id}
                          />
                          {/* Detalle OI */}
                          <AccountAssignmentObjectDetail data={well?.imputationObject} />
                        </div>
                      )}
                  </>
                </Row>
                <hr />
              </>
            );
          })}
      </div>
    </ModalGeneric>
  );
};

AddEventModal.propTypes = {
  showAddEventModal: PropTypes.bool,
  setShowAddEventModal: PropTypes.func.isRequired,
  setWithOutEventAssigned: PropTypes.func.isRequired,
  requestId: PropTypes.number.isRequired,
  ubicationType: PropTypes.shape({
    id: PropTypes.number,
    nombre: PropTypes.string
  }).isRequired
};

AddEventModal.defaultProps = {
  showAddEventModal: false
};

export default AddEventModal;
